import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { ScrollFade } from '@/components/ScrollFade'
import { SvgFrameSequence } from '@/components/SvgFrameSequence'
import { useInView } from '@/lib/useInView'
import { track } from '@/lib/analytics'

export function FeatureTokenAnonymization() {
  const { t } = useTranslation()
  const { ref: visRef, inView } = useInView<HTMLElement>({ once: true, threshold: 0.5 })

  useEffect(() => {
    if (inView) track('feature_block_visible', { block: 'tokenAnonymization' })
  }, [inView])

  return (
    <section ref={visRef} id="feature-token-anonymization" className="max-w-7xl mx-auto px-5 md:px-8 py-7">
      <div className="grid md:grid-cols-2 gap-10 items-center">
        <ScrollFade delay={120} className="md:order-2">
          <div className="w-full max-w-md rounded-lg overflow-hidden border border-mono-800/[0.16] dark:border-mono-100/[0.16]">
            <SvgFrameSequence name="token-anonymization" ariaLabel={t('alt.tokenAnonymization')} />
          </div>
        </ScrollFade>
        <ScrollFade className="md:order-1">
          <h2 className="text-4xl md:text-5xl font-bold font-display">
            {t('featureBlocks.tokenAnonymization')}
          </h2>
          <p className="mt-4 text-lg opacity-80 max-w-prose">{t('lorem:featureBlocks.tokenAnonymization.headline')}</p>
          <p className="mt-3 text-lg opacity-70 max-w-prose">{t('lorem:featureBlocks.tokenAnonymization.body')}</p>
        </ScrollFade>
      </div>
    </section>
  )
}
